//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { gql } from 'graphql-tag'
import { sync } from 'vuex-pathify'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import 'vue2-datepicker/locale/nl'
import 'vue2-datepicker/locale/en'
import { Language, ContentType } from '@constants'
import CloseThickIcon from 'vue-material-design-icons/CloseThick.vue'
import CalendarIcon from 'vue-material-design-icons/Calendar.vue'

const DATA_QUERY = gql`
  query {
    calendarItemTypes(order: [{ id: ASC }], first: 999) {
      nodes {
        id
        name
        externalId
      }
    }
  }
`

const CALENDAR_ITEMS = gql`
  query ($where: CalendarItemFilterInput) {
    calendarItems(where: $where, order: [{ startAt: ASC }], first: 500) {
      nodes {
        id
        externalId
        title
        startAt
        durationDays
        content
        organiser
        city
        country
        url
        calendarItemType {
          id
          name
        }
      }
    }
  }
`

export default {
  name: 'Calendars',
  components: { DatePicker, CloseThickIcon, CalendarIcon },
  scrollToTop: true,
  data() {
    return {
      showPlaceholder: true,
      placeholders: 3,
      calendarItems: [],
      calendarItemTypes: [],
      dateFrom: null,
      dateTo: null,
      filters: {
        date: new Date(),
        calendarItemTypeId: null
      },
      ContentType,
      Language
    }
  },
  fetchOnServer: false,
  async fetch() {
    this.dateFrom = this.$dayjs(this.filters.date).startOf('month')
    this.dateTo = this.$dayjs(this.filters.date).endOf('month')

    await this.refresh()
  },
  computed: {
    filterOptions: sync('filters'),
    currentBreakPoint() {
      return this.$store.get('app/currentBreakPoint') || 'md'
    },
    language() {
      return this.$store.get('language/locale') || 'en'
    },
    languageId() {
      return this.language === 'en' ? Language.ENGLISH : Language.DUTCH
    }
  },
  watch: {
    async languageId() {
      await this.refresh(true)
      this.setBreadcrumb({
        isShow: true,
        pageTitle: this.$t('calendars.calendars')
      })
      this.setFilters({
        isShow: true,
        showFilterTotal: false,
        enabled: false,
        header: this.$t('calendars.calendar_from_to', {
          from: this.dateFrom ? this.dateFrom.format('MMM YYYY') : ''
        }),
        isCustomFilter: true
      })
    }
  },
  beforeDestroy() {
    this.$nuxt.$off('onFiltersClear')
  },
  mounted() {
    this.setBreadcrumb({
      isShow: true,
      pageTitle: this.$t('calendars.calendars')
    })
    this.setFilters({
      isShow: true,
      showFilterTotal: false,
      enabled: false,
      header: this.$t('calendars.calendar_from_to', {
        from: this.dateFrom ? this.dateFrom.format('MMM YYYY') : ''
      }),
      isCustomFilter: true
    })

    this.$nuxt.$on('onFiltersClear', this.onFiltersClear)
  },
  methods: {
    async refresh(purge = false) {
      this.filters.isLoading = true

      try {
        const { data } = await this.$apollo.query({
          query: DATA_QUERY,
          fetchPolicy: purge ? 'network-only' : 'cache-first'
        })

        this.calendarItemTypes = data.calendarItemTypes.nodes

        await this.fetchCalendars()
      } catch (error) {
        this.handleError(error)
      } finally {
        this.filters.isLoading = false
      }
    },
    async fetchCalendars() {
      this.showPlaceholder = true

      const where = {}

      if (this.filters.date) {
        where.startAt = {
          gte: this.dateFrom
        }
        where.or = [
          {
            languageId: {
              eq: this.languageId
            }
          },
          {
            showOnDutchPage: {
              eq: true
            }
          }
        ]
      }

      if (this.filters.calendarItemTypeId) {
        where.calendarItemTypeId = {
          eq: this.filters.calendarItemTypeId
        }
      }

      try {
        const { data } = await this.$apollo.query({
          query: CALENDAR_ITEMS,
          variables: {
            where
          }
        })

        const monthItems = data.calendarItems.nodes.filter((x) => this.$dayjs(x.startAt) <= this.dateTo)
        this.calendarItems = data.calendarItems.nodes.slice(0, Math.max(monthItems.length, 50))
      } catch (error) {
        this.handleError(error)
      } finally {
        this.showPlaceholder = false
        this.filters.isLoading = false
      }
    },
    onDateChange() {
      this.dateFrom = this.$dayjs(this.filters.date).startOf('month')
      this.dateTo = this.$dayjs(this.filters.date).endOf('month')
      this.filterOptions.header = this.$t('calendars.calendar_from_to', {
        from: this.dateFrom ? this.dateFrom.format('MMM YYYY') : ''
      })

      this.onFilterChange()
    },
    async onFilterChange() {
      await this.fetchCalendars()

      this.filterOptions.isShowClear =
        (this.filters.date !== null && !this.$dayjs(this.filters.date).isSame(this.$dayjs(), 'month')) ||
        this.filters.calendarItemTypeId !== null
    },
    async onFiltersClear() {
      this.filters.date = new Date()
      this.filters.calendarItemTypeId = null

      await this.onDateChange()
    }
  }
}
